<div class="feedback-comment" *ngIf="!!url" #componentContainer>
    <div class="text">
        <div *ngIf="task.is_title" class="title my-color-blue" [innerHTML]="title | safeHtml"></div>
        <ion-checkbox *ngIf="canChangeStatus && task.task" class="My-checkbox" [(ngModel)]="task.status" [disabled]="disabled"
                      (click)="changeStatus(task)"></ion-checkbox>
        <div class="status" *ngIf="!canChangeStatus && task.task" [ngClass]="{completed: task.status}"></div>
    </div>
    <div *ngIf="!!description" class="text"><strong>{{description}}</strong></div>
    <video *ngIf="isVideo" class="body-text" controls (play)="onPlay()" crossorigin="anonymous">
        <source [src]="url">
    </video>
    <div *ngIf="isYoutube" class="youtube" #youtubeContainer></div>
    <div *ngIf="isMeetingPulse" class="meetingpulse">
      <iframe [src]="url | safeUrl" style="border:none;" allow="encrypted-media" credentialless>
      </iframe>
    </div>
    <div *ngIf="isSIM && !!simSrc" class="sim">
        <iframe [srcdoc]="simSrc" credentialless></iframe>
    </div>
    <div *ngIf="isHyperbound && hyperboundUrl" class="hyperbound">
        <iframe [src]="hyperboundUrl | safeUrl" allow="microphone *; clipboard-read *; clipboard-write *"></iframe>
    </div>
  <div *ngIf="isHyperbound && !hyperboundUrl" class="hyperbound">
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  </div>
    <div *ngIf="isImage" class="image">
        <img [src]="url" crossorigin="anonymous" />
    </div>
</div>
